import React from 'react';
import './LoadingPage.css'
import LogoLoading from '../Assets/Svg/Falla_Plaza_Rodrigo.svg'

export const Loader = () => {
  return (
    <div className="app-loading-screen">
      <div className="app-loading-inner">
        <div className="app-loading-spinner">
          <img src={LogoLoading} alt="LogoLoading" className="app-loading-logo" /></div>
      </div>
    </div>
  );
};
